import { useContext, useEffect, useState } from 'react';
import { ref, listAll, getDownloadURL } from 'firebase/storage';
import { ParentContext } from '../ParentContext';

export const useStorage = ({ image_name, forClientStorage, currentLongPress }) => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainStorage } = app_state ?? {}

  const [storageUrls, setStorageUrls] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!image_name) return;

    const fetchFiles = async () => {
      setLoading(true);
      setError(null);

      try {
        const folderPath = forClientStorage ? `clients/${pathViews.clients}/profiles/${image_name}` : `clients/${pathViews.clients}/events/${pathViews.events}/pages/${currentLongPress?.uivi}/${currentLongPress?.uiviKey}`

        const folderRef = ref(mainStorage, folderPath);
        const result = await listAll(folderRef);

        let fullUrl = null;
        let thumbUrl = null;

        for (const itemRef of result.items) {
          const name = itemRef.name.toLowerCase();

          if (name.includes('full')) {
            fullUrl = await getDownloadURL(itemRef);
          }

          if (name.includes('thumbnail')) {
            thumbUrl = await getDownloadURL(itemRef);
          }
        }


        const _storageUrls = {
          full: fullUrl,
          thumbnail: thumbUrl
        }

        setStorageUrls(_storageUrls);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchFiles();

  }, [image_name]);

  return { storageUrls, loading, error };
};
